import React from 'react';
import { AboutZev } from '../components/AboutZev';
import { Facilities } from '../components/Facilities';
import { FinalCTA } from '../components/FinalCTA';
import { Hero } from '../components/Hero';
import { LivingFeed } from '../components/LivingFeed';
import { Location } from '../components/Location';
import { PathwayCards } from '../components/PathwayCards';
import { TrustDiscovery } from '../components/TrustDiscovery';
export function HomePage() {
  return <>
      <Hero data-id="element-401" data-mp="2s1fpekhhy9k8" />
      <PathwayCards data-id="element-402" data-mp="2s1o48hx6joy2" />
      <LivingFeed data-id="element-403" data-mp="2s27ct80xx0zf" />
      <Facilities data-id="element-404" data-mp="2s2qviqyeztei" />
      <AboutZev data-id="element-405" data-mp="2rzbbd9pvvu68" />
      <TrustDiscovery data-id="element-406" data-mp="2rzl5n9hyonhq" />
      <Location data-id="element-407" data-mp="36qu1i0cgj53b" />
      <FinalCTA data-id="element-408" data-mp="36rdhvcmgllf8" />
    </>;
}